var map = {
	"./alb.svg": [
		1934,
		934
	],
	"./asg.svg": [
		2758,
		758
	],
	"./aurora.svg": [
		9399,
		399
	],
	"./aws.svg": [
		9054,
		54
	],
	"./dynamodb.svg": [
		7447,
		447
	],
	"./ebs.svg": [
		7961,
		961
	],
	"./ec2_instance.svg": [
		6251,
		251
	],
	"./ecr.svg": [
		6727,
		727
	],
	"./efs.svg": [
		4837,
		837
	],
	"./eks.svg": [
		1454,
		454
	],
	"./iam-role.svg": [
		5739,
		739
	],
	"./kms.svg": [
		1210,
		210
	],
	"./rds.svg": [
		6588,
		588
	],
	"./redis.svg": [
		1560,
		560
	],
	"./redshift.svg": [
		4500,
		500
	],
	"./s3.svg": [
		2125,
		125
	],
	"./secretmanager.svg": [
		6748,
		748
	],
	"./sg.svg": [
		5921,
		921
	],
	"./sns.svg": [
		43,
		43
	],
	"./sqs.svg": [
		7678,
		678
	],
	"./ssm.svg": [
		4197,
		578
	],
	"./vpc.svg": [
		8263,
		644
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3197;
module.exports = webpackAsyncContext;